// Rich exam data — powers /exams (overview list) and /exams/:slug (individual detail pages).

export const exams = [
  {
    slug: 'fmge',
    icon: 'ClipboardList',
    variant: 'brand',
    name: 'FMGE Exam',
    short: 'FMGE',
    subtitle: 'Foreign Medical Graduate Examination',
    tagline: 'India Licensing Test for MBBS Graduates from Abroad',
    heroDesc:
      'Conducted by the National Board of Examinations (NBEMS), FMGE is the mandatory screening test that Indian citizens holding an MBBS/MD from a foreign university must clear before they can register with the State/National Medical Council and practise medicine in India.',
    quickFacts: [
      { label: 'Frequency', value: 'Twice a year' },
      { label: 'Months', value: 'June & December' },
      { label: 'Total MCQs', value: '300' },
      { label: 'Duration', value: '5 hours (2 parts)' },
      { label: 'Passing Score', value: '150 / 300 (50%)' },
      { label: 'Conducted By', value: 'NBEMS, India' },
    ],
    eligibility: [
      'Indian citizen / OCI holder',
      'Primary medical qualification (MBBS/MD Physician) from a foreign medical institution',
      'Institution must be listed in the World Directory of Medical Schools (WDOMS)',
      'For post-2019 admissions — NEET UG qualification is mandatory',
      'Applicable to graduates before the NExT rollout (batches admitted up to Nov 2023)',
    ],
    pattern: [
      { label: 'Mode', value: 'Computer-Based Test (CBT)' },
      { label: 'Sections', value: '2 papers of 150 MCQs each' },
      { label: 'Duration per paper', value: '2.5 hours' },
      { label: 'Marking', value: '+1 for correct · 0 for wrong (No negative marking)' },
      { label: 'Medium', value: 'English' },
      { label: 'Attempts', value: 'Unlimited' },
    ],
    syllabus: [
      { section: 'Pre-Clinical', items: ['Anatomy', 'Physiology', 'Biochemistry'] },
      { section: 'Para-Clinical', items: ['Pathology', 'Microbiology', 'Pharmacology', 'Forensic Medicine'] },
      { section: 'Clinical', items: ['General Medicine', 'General Surgery', 'Paediatrics', 'Obstetrics & Gynaecology', 'Community Medicine (PSM)', 'Ophthalmology', 'Otorhinolaryngology (ENT)', 'Psychiatry', 'Dermatology & Venereology', 'Anaesthesiology', 'Radiology'] },
    ],
    fees: 'INR 7,080 (incl. 18% GST) — payable online via NBEMS portal',
    validity: 'Once qualified, the FMGE certificate is permanent — no re-attempt required',
    prep: [
      'Start FMGE preparation from Year 4 of your MBBS in Russia',
      'Focus on high-yield NBEMS subjects: Medicine, PSM, Pharmacology, Anatomy',
      'Practice with previous 10 years of FMGE question papers',
      'Take at least 15 full-length mock tests before the final exam',
      'Join a structured FMGE coaching (offline or online) 4–6 months before',
    ],
    afterQualify: 'On clearing FMGE, complete a 12-month supervised Compulsory Rotatory Medical Internship (CRMI) at an NMC-approved Indian hospital, then apply for permanent registration with your State/National Medical Council.',
    faqs: [
      { q: 'How many attempts are allowed?', a: 'Unlimited — you can appear as many times as needed until you clear.' },
      { q: 'Is negative marking involved?', a: 'No. FMGE has no negative marking, so attempting every question is recommended.' },
      { q: 'When will FMGE be discontinued?', a: 'FMGE is being phased out for batches admitted from November 2023 onwards — those students will appear for NExT instead. Pre-2024 batches will continue with FMGE for the foreseeable future.' },
      { q: 'Can I appear for FMGE while still in the 6th year?', a: 'No. You must first complete the 6-year MBBS programme (including the 1-year rotational internship at the foreign university) and have your final degree in hand.' },
    ],
  },
  {
    slug: 'next',
    icon: 'Medal',
    variant: 'primary',
    name: 'NExT Exam',
    short: 'NExT',
    subtitle: 'National Exit Test',
    tagline: 'Unified Licensing + PG Entrance Exam by NMC',
    heroDesc:
      'The National Exit Test (NExT) is the new common exit examination being rolled out by the National Medical Commission (NMC). It replaces the FMGE for foreign medical graduates and the NEET-PG for Indian graduates — a single exam that acts as both the licentiate exam and the PG admission ranking test.',
    quickFacts: [
      { label: 'Steps', value: 'NExT Step 1 + Step 2' },
      { label: 'Rollout', value: 'From 2024-2025 batches onwards' },
      { label: 'Step 1', value: 'Theory (MCQ + Reasoning)' },
      { label: 'Step 2', value: 'Practical / Clinical' },
      { label: 'Purpose', value: 'Licensing + PG entrance in one' },
      { label: 'Conducted By', value: 'NMC / NBEMS' },
    ],
    eligibility: [
      'All MBBS graduates from NMC-approved institutions (Indian & Foreign)',
      'For foreign graduates: WDOMS-listed foreign medical school',
      'NEET-UG qualified admission (mandatory for post-2019 admissions)',
      'Completion of 6-year MBBS programme (including 1-year internship)',
    ],
    pattern: [
      { label: 'Step 1 mode', value: 'Computer-Based Test' },
      { label: 'Step 1 sections', value: '6 clinical + para-clinical papers' },
      { label: 'Step 2', value: 'Clinical practical assessment' },
      { label: 'Duration', value: 'Step 1 spread over 3 days, ~4 hrs/day' },
      { label: 'Score usage', value: 'Same score for licensing + PG ranking' },
      { label: 'Language', value: 'English' },
    ],
    syllabus: [
      { section: 'NExT Step 1 — Theory', items: ['General Medicine + allied (Dermatology, Psychiatry, Radiotherapy)', 'General Surgery + allied (Orthopedics, Anaesthesia, Radiodiagnosis)', 'Obstetrics & Gynaecology', 'Paediatrics', 'Ophthalmology + ENT', 'Community Medicine + Forensic Medicine + Emergency Medicine'] },
      { section: 'NExT Step 2 — Practical', items: ['Bedside clinical exam', 'OSCE-style stations', 'Communication & ethics', 'Clinical decision-making'] },
    ],
    fees: 'To be announced by NBEMS (expected in line with NEET-PG structure)',
    validity: 'Qualifying certificate is permanent — the ranking score, however, is used for PG admission in the year of appearance.',
    prep: [
      'Focus on comprehensive final-year MBBS clinical subjects',
      'Practice OSCE-style stations for Step 2 with peers',
      'Solve NExT sample papers released by NMC / NBEMS',
      'Join a Next-focused coaching from Year 5 onwards',
      'Regularly review case-based clinical reasoning questions',
    ],
    afterQualify: 'After clearing both NExT Steps 1 & 2, foreign graduates complete a 12-month CRMI at an NMC-approved Indian hospital and receive their permanent medical registration.',
    faqs: [
      { q: 'Will NExT replace FMGE completely?', a: 'Yes, for the 2024–2025 batch onwards. FMGE will continue for pre-2024 batches.' },
      { q: 'Can I use the same NExT score for both licensing and PG?', a: 'Yes. Step 1 score is used both as the qualifying/licensing marker and as the ranking basis for PG admissions.' },
      { q: 'How is NExT different from NEET-PG?', a: 'NExT replaces NEET-PG entirely — there will be only one exam that both licenses you and ranks you for PG seats.' },
      { q: 'How many attempts are allowed?', a: 'Multiple attempts are permitted per NMC regulations, but the best score in a limited window is considered for PG ranking.' },
    ],
  },
  {
    slug: 'admission-russia',
    icon: 'GraduationCap',
    variant: 'brand',
    name: 'Admission Exam (Russia)',
    short: 'Admission',
    subtitle: 'University Entry Assessment',
    tagline: 'Qualifying test conducted after arrival at the Russian university',
    heroDesc:
      'A short qualifying assessment conducted by the Russian medical university within 1–2 weeks of your arrival on campus. It confirms your basic proficiency in English, Physics, Chemistry and Biology and is used to place you in the correct English-medium academic group. It is qualifying in nature — not a competitive ranking exam.',
    quickFacts: [
      { label: 'When', value: 'Within 1–2 weeks of campus arrival' },
      { label: 'Format', value: 'Short written / oral test' },
      { label: 'Nature', value: 'Qualifying (Pass / Fail)' },
      { label: 'Duration', value: '1–2 hours' },
      { label: 'Medium', value: 'English' },
      { label: 'Purpose', value: 'Placement in English batch' },
    ],
    eligibility: [
      'Must have secured a confirmed admission letter from the Russian university',
      'Must have qualified NEET-UG (mandatory for Indian students)',
      'Must have Class 12 with PCB (min 50%; 40% for SC/ST/OBC as per NMC)',
      'Valid student visa & campus arrival within stipulated window',
    ],
    pattern: [
      { label: 'Sections', value: 'Physics, Chemistry, Biology + Basic English' },
      { label: 'Question type', value: 'Short answer / MCQ / oral' },
      { label: 'Duration', value: '1–2 hours total' },
      { label: 'Marking', value: 'Qualifying — no competitive rank' },
      { label: 'Medium', value: 'English' },
      { label: 'Result', value: 'Same-day / next-day announcement' },
    ],
    syllabus: [
      { section: 'Physics', items: ['Mechanics', 'Thermodynamics', 'Electricity & Magnetism (Class 11–12 level)'] },
      { section: 'Chemistry', items: ['Organic basics', 'Inorganic reactions', 'Physical chemistry (Class 11–12 level)'] },
      { section: 'Biology', items: ['Human physiology', 'Cell biology', 'Genetics', 'Botany + Zoology (Class 11–12 level)'] },
      { section: 'English', items: ['Reading comprehension', 'Basic grammar', 'Spoken interaction (5-min oral)'] },
    ],
    fees: 'Included in university admission fee — no separate exam fee',
    validity: 'Result valid only for that admission year — used to confirm your enrolment',
    prep: [
      'Revisit your NEET / Class 12 PCB notes before travelling',
      'Practise English speaking with peers or online partners',
      'Do NOT stress — pass criteria is basic proficiency, not competitive',
      'Carry your NEET score card + Class 12 marksheet for verification',
    ],
    afterQualify: 'Once you clear, you are officially enrolled with the university and issued your student ID card. Orientation and Russian language classes begin the same week.',
    faqs: [
      { q: 'What if I do not clear the admission test?', a: 'Universities offer a re-take within a week. Failing that, a 1–2 week prep programme is provided before the second attempt. Nearly 99% of Indian students clear on the first attempt.' },
      { q: 'Is Russian language tested?', a: 'No. English is the medium — Russian language classes start AFTER enrolment as part of the regular curriculum.' },
      { q: 'Do I need to bring any documents?', a: 'Yes — your NEET UG score card, Class 12 marksheet, passport, admission letter and visa are checked before the exam.' },
    ],
  },
  {
    slug: 'semester-annual',
    icon: 'CalendarDays',
    variant: 'primary',
    name: 'Semester & Annual Exams',
    short: 'Semester',
    subtitle: 'Continuous Academic Assessment',
    tagline: 'European-style two-semester system with formal end-of-year exams',
    heroDesc:
      'Russian medical universities follow the European two-semester structure. Students face continuous internal assessment throughout the year — class tests, practicals, viva-voce — culminating in formal end-of-year theory + oral exams for each subject. Attendance of at least 75% is compulsory for exam eligibility.',
    quickFacts: [
      { label: 'Semesters per year', value: '2' },
      { label: 'Sem 1', value: 'September – January' },
      { label: 'Sem 2', value: 'February – June' },
      { label: 'Assessment', value: 'Continuous + Annual' },
      { label: 'Attendance', value: 'Minimum 75%' },
      { label: 'Grading', value: '5-point Russian scale' },
    ],
    eligibility: [
      'Enrolled full-time student of the university',
      'Minimum 75% attendance in each subject',
      'All continuous-assessment credits completed',
      'No pending internal-test failures',
      'Valid student visa & tuition fee cleared for the semester',
    ],
    pattern: [
      { label: 'Continuous tests', value: 'Every 4–6 weeks per subject' },
      { label: 'Practicals', value: 'Lab / clinical demonstrations' },
      { label: 'Annual exam format', value: 'Theory (written) + Oral (viva)' },
      { label: 'Duration', value: '2–3 hours theory + 20–30 min viva' },
      { label: 'Marking scale', value: '5 (Excellent) · 4 (Good) · 3 (Satisfactory) · 2 (Fail)' },
      { label: 'Language', value: 'English (with basic Russian for viva)' },
    ],
    syllabus: [
      { section: 'Year 1', items: ['Anatomy', 'Histology', 'Biochemistry', 'Latin', 'Russian Language (basic)'] },
      { section: 'Year 2', items: ['Physiology', 'Microbiology', 'Biology', 'Bio-organic Chemistry'] },
      { section: 'Year 3', items: ['Pathology', 'Pharmacology', 'Propedeutics of Internal Medicine', 'General Surgery'] },
      { section: 'Year 4–5', items: ['Internal Medicine', 'Surgery', 'OBG', 'Paediatrics', 'Neurology', 'Psychiatry', 'Community Medicine'] },
      { section: 'Year 6', items: ['Internship rotations', 'Final State Exam preparation'] },
    ],
    fees: 'Included in your annual tuition — no separate examination fee',
    validity: 'Each year’s passing certificate is a prerequisite for progression to the next year',
    prep: [
      'Attend all classes — attendance is strictly enforced',
      'Complete continuous-assessment tests on time',
      'Practise oral viva with study groups (viva carries significant weight)',
      'Use standard Russian + international textbooks (Guyton, Robbins, Katzung)',
      'Consult professors during their scheduled consultation hours',
    ],
    afterQualify: 'On passing all subjects of a semester, you receive a formal semester certificate and progress to the next term. Backlogs must be cleared within the retake window before the next semester begins.',
    faqs: [
      { q: 'What happens if I fail a subject?', a: 'You get a re-examination window (2–3 attempts) before the next academic year begins. Persistent failure may lead to repeating the year.' },
      { q: 'Are semester exams conducted in Russian?', a: 'The theory papers are in English. The oral viva is largely in English but conversational Russian may help when interacting with senior professors.' },
      { q: 'Can I skip attendance?', a: 'No — below 75% attendance disqualifies you from appearing in the semester exam for that subject.' },
    ],
  },
  {
    slug: 'final-state',
    icon: 'Flag',
    variant: 'brand',
    name: 'Final State Exam',
    short: 'Final State',
    subtitle: 'Graduation & MBBS Degree Award',
    tagline: 'Comprehensive 6th-year exam that culminates in the MBBS diploma',
    heroDesc:
      'Conducted at the end of the 6th year (after the 12-month rotational internship), the Final State Exam is a comprehensive multi-subject assessment covering every major clinical discipline. Clearing this exam is the final step in earning the MD Physician (MBBS-equivalent) diploma awarded by the Russian State Examination Commission.',
    quickFacts: [
      { label: 'When', value: 'Final semester of 6th year' },
      { label: 'Format', value: 'Theory + Clinical (multi-day)' },
      { label: 'Certifying body', value: 'Russian State Examination Commission' },
      { label: 'Outcome', value: 'MBBS (MD Physician) Diploma' },
      { label: 'Duration', value: 'Spread over 2–3 weeks' },
      { label: 'Medium', value: 'English' },
    ],
    eligibility: [
      'Completion of all 5 years of academic coursework + Year 6 internship',
      'All internal assessments and semester exams cleared',
      'Attendance and clinical-rotation logbook complete',
      'No pending university dues',
      'Fulfillment of thesis/research submission (where applicable)',
    ],
    pattern: [
      { label: 'Sections', value: 'Theory (written / MCQ) + Clinical (bedside)' },
      { label: 'Subjects', value: 'Medicine, Surgery, OBG, Paediatrics, PSM, Emergency' },
      { label: 'Clinical exam', value: 'Real-patient case presentation + viva' },
      { label: 'Board size', value: '5–7 senior professors + external examiner' },
      { label: 'Passing', value: 'Independent pass in each subject' },
      { label: 'Grading', value: '5-point scale (min 3 to pass)' },
    ],
    syllabus: [
      { section: 'Internal Medicine', items: ['Cardiology', 'Pulmonology', 'Nephrology', 'Endocrinology', 'Gastroenterology', 'Rheumatology'] },
      { section: 'Surgery', items: ['General Surgery', 'Orthopedics', 'Urology', 'Neurosurgery basics', 'Emergency surgical care'] },
      { section: 'Obstetrics & Gynaecology', items: ['Antenatal care', 'Labour management', 'Gynaecological disorders', 'Family planning'] },
      { section: 'Paediatrics', items: ['Neonatology', 'Growth & development', 'Common childhood illnesses', 'Immunisation'] },
      { section: 'Community Medicine & Emergency', items: ['Public health', 'Epidemiology', 'Emergency triage', 'Ethics & communication'] },
    ],
    fees: 'Included in your final-year tuition — no separate exam fee',
    validity: 'The MBBS (MD Physician) diploma is issued for lifetime once you clear Final State Exam',
    prep: [
      'Start final-year revision from the beginning of Year 6',
      'Log every clinical case during internship rotations for viva recall',
      'Practise real-patient case presentations with senior interns',
      'Use standard clinical texts: Harrison, Bailey & Love, Nelson, Williams',
      'Do FMGE / NExT preparation in parallel — content overlaps 80%',
    ],
    afterQualify: 'You receive your MD Physician diploma (equivalent to MBBS) from the university state commission. You can then apply for FMGE / NExT in India, USMLE (USA), PLAB (UK) or licensing exams in any of the 195+ WHO-recognised countries.',
    faqs: [
      { q: 'How long does the Final State Exam take?', a: 'It is typically spread over 2–3 weeks with different subjects examined on different days — allowing focused prep per subject.' },
      { q: 'What is the passing criteria?', a: 'A minimum grade of 3 (Satisfactory) is required in each subject independently. Failing any one subject requires a retake for that subject before the diploma is issued.' },
      { q: 'When will I receive my diploma?', a: 'The MD Physician diploma is typically issued within 30–45 days of successfully completing the Final State Exam, along with apostille documents for international use.' },
    ],
  },
];

export function getExam(slug) {
  return exams.find((e) => e.slug === slug);
}
